import { render, staticRenderFns } from "./CategoryDocuments.vue?vue&type=template&id=6c4a6eea"
import script from "./CategoryDocuments.vue?vue&type=script&lang=ts"
export * from "./CategoryDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports